import React, { Component } from 'react';
import { List, ListItemButton, ListItemText, Paper, SxProps, Theme } from '@mui/material';

import { getTemplateDisplayName } from '@paragon/client-tools';
import { AnnotationTemplate } from '@paragon/contract-library';

import { SecondaryAction } from './TemplateAction';
import TemplateActions from './TemplateActions';

interface Props {
  templates: AnnotationTemplate[];
  selectedTemplateId?: number;
  onSelectTemplate?: (annotationTemplateId: number) => void;

  showGroups?: boolean;

  secondaryActions?: SecondaryAction[];
  placeholder?: any;

  sx?: SxProps<Theme>;
}

export default class TemplateList extends Component<Props> {
  renderListItem = (template: AnnotationTemplate) => {
    const { selectedTemplateId: selectedTemplate, onSelectTemplate, showGroups, secondaryActions } = this.props;

    return (
      <ListItemButton
        key={template.id}
        onClick={() => (onSelectTemplate ? onSelectTemplate(template.id) : null)}
        sx={selectedTemplate === template.id ? { bgcolor: 'selectedList.main' } : null}
      >
        <TemplateActions template={template} actions={secondaryActions} onLeft />
        <ListItemText
          sx={{
            '& .ListItemText-primary': { wordWrap: 'break-word', width: '80%' },
          }}
          primary={getTemplateDisplayName(template)}
          secondary={showGroups ? template.group || 'unassigned' : undefined}
        />
        <TemplateActions template={template} actions={secondaryActions} />
      </ListItemButton>
    );
  };

  render() {
    const { templates, placeholder } = this.props;

    if (templates.length === 0 && placeholder) {
      return placeholder;
    }

    return (
      <Paper>
        <List component="nav" sx={this.props.sx}>
          {templates.map(this.renderListItem)}
        </List>
      </Paper>
    );
  }
}
